import request from '../utils/adminrequest'


export function login(data) {
    return request({
    url: '/login',
    method: 'post',
    data
    })
}

export function captcha() {
    return request({
    url: '/captcha',
    method: 'get',
    })
}

export function createCustomer(data) {
    return request({
    url: '/customer',
    method: 'post',
    data
    })
}

export function getCustomers(params) {
    return request({
    url: '/customer',
    method: 'get',
    params
    })
}

export function updateCustomers(id,data) {
    return request({
    url: `/customer/${id}`,
    method: 'put',
    data
    })
}

export function delCustomer(id,data) {
    return request({
    url: `/customer/${id}`,
    method: 'delete',
    data
    })
}


export function createCard( data){
    return request({
    url: '/card',
    method: 'post',
    data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
    }) 
}

export function updateCard(id, data){
    return request({
    url: `/card/${id}`,
    method: 'put',
    data,
    headers: {
        'Content-Type': 'multipart/form-data'
    }
    }) 
}

export function delCard(id, data){
    return request({
    url: `/card/${id}`,
    method: 'delete',
    data,
    }) 
}

export function GenQrcode(data){
    return request({
    url: '/customer/qrcode',
    method: 'post',
    data,
    }) 
}

export function getShops(params){
    return request({
    url: '/shop',
    method: 'get',
    params
    })
}


export function createShop(data){
    return request({
    url: '/shop',
    method: 'post',
    data
    })
}


export function updateShop(id, data){
    return request({
    url: `/shop/${id}`,
    method: 'put',
    data
    })
}

export function deleteShop(id, data){
    return request({
    url: `/shop/${id}`,
    method: 'delete',
    data
    })
}

// ========== 案例管理 ==========

/**
 * 获取案例列表
 * @param {object} params - 查询参数
 * @returns {Promise}
 */
export function getCases(params) {
    return request({
    url: '/case',
    method: 'get',
    params
    })
}

/**
 * 创建/保存案例
 * @param {string} jsonData - JSON字符串格式的案例数据
 * @returns {Promise}
 */
export function saveCase(jsonData) {
    return request({
    url: '/case',
    method: 'post',
    data: { data: jsonData },
    headers: {
        'Content-Type': 'application/json'
    }
    })
}

/**
 * 更新案例
 * @param {number|string} id - 案例ID
 * @param {string} jsonData - JSON字符串格式的案例数据
 * @returns {Promise}
 */
export function updateCase(id, jsonData) {
    return request({
    url: `/case/${id}`,
    method: 'put',
    data: { data: jsonData },
    headers: {
        'Content-Type': 'application/json'
    }
    })
}

/**
 * 删除案例
 * @param {number|string} id - 案例ID
 * @returns {Promise}
 */
export function deleteCase(id) {
    return request({
    url: `/case/${id}`,
    method: 'delete'
    })
}
